/**
 * Profile Service
 * Register Angular Services for Profiles
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 * @return Resource
 */

angular.module('flsServices').factory('Profile', ['$resource', function($resource){
    return $resource('/api/v2/profile/:id');
}]);
